// import React from 'react';
// import { useTable } from 'react-table';
// import './Table.css' ;
// import { data } from './Data/Data';

// const Table = () => {
//   const columns = React.useMemo(
//     () => [
//       {
//         Header: "ID",
//         accessor: "id",
//       },
//       {
//         Header: "First Name",
//         accessor: "first_name",
//       },
//       {
//         Header: "Last Name",
//         accessor: "last_name",
//       },
//       {
//         Header: "Email",
//         accessor: "email",
//       },
//       {
//         Header: "Phone num",
//         accessor: "Phone number",
//       },
//       {
//         Header: "Department",
//         accessor: "department",
//       },
//       {
//         Header: "Status",
//         accessor: "status",
//       },
//       {
//         Header: "Action",
//         accessor: "action",
//       },
//     ],
//     []
//   );

//   const {
//     getTableProps,
//     getTableBodyProps,
//     headerGroups,
//     rows,
//     prepareRow,
//   } = useTable({ columns, data });

//   return (
//     <div className="App">
//       <div className="table-container">
//         <table {...getTableProps()}>
//           <thead>
//             {headerGroups.map((headerGroup) => (
//               <tr {...headerGroup.getHeaderGroupProps()}>
//                 {headerGroup.headers.map((column) => (
//                   <th {...column.getHeaderProps()}>{column.render("Header")}</th>
//                 ))}
//               </tr>
//             ))}
//           </thead>
//           <tbody {...getTableBodyProps()}>
//             {rows.map((row) => {
//               prepareRow(row);
//               return (
//                 <tr {...row.getRowProps()} className={row.original.first_name.toLowerCase()}>
//                   {row.cells.map((cell) => (
//                     <td {...cell.getCellProps()}>
//                       {cell.column.id === 'first_name' ? (
//                         <div className='firstName'>
//                           <span className='first_letters'>
//                             {cell.row.original.first_name.charAt(0) + cell.row.original.last_name.charAt(0)}
//                           </span>
//                           {cell.render("Cell")}
//                         </div>
//                       ) : cell.column.id === 'status' ? (
//                         <span className={`${cell.row.original.status === "Active" ? 'active' : cell.row.original.status === "Pending" ? 'pending' : 'unactive'}`}>{cell.render("Cell")}</span>
//                       ) : (
//                         cell.render("Cell")
//                       )}
//                     </td>
//             ))}
//                 </tr>
//               );
//             })}
//           </tbody>
//         </table>
//       </div>

//     </div>
//   );
// };

// export default Table;

import React, { useState } from 'react';
import { useTable } from 'react-table';
import './Table.css';
import { data } from './Data/Data';

const Table = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);

  const openModal = (rowData) => {
    setSelectedRowData(rowData);
    setIsModalOpen(true);
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
      },
      {
        Header: "First Name",
        accessor: "first_name",
      },
      {
        Header: "Last Name",
        accessor: "last_name",
      },
      {
        Header: "Email",
        accessor: "email",
      },
      {
        Header: "Phone num",
        accessor: "Phone number",
      },
      {
        Header: "Department",
        accessor: "department",
      },
      {
        Header: "Status",
        accessor: "status",
      },
      {
        Header: "Action",
        accessor: "action",
      },
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({ columns, data });
  // ... (rest of your code)

  return (
    <div className="App">
      <table {...getTableProps()}>
      {/* ... (your table code) */}
      <thead>
          {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps()}>{column.render("Header")}</th>
                ))}
              </tr>
            ))}
          </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map((row) => {
          prepareRow(row);
          return (
            <tr {...row.getRowProps()} className={row.original.first_name.toLowerCase()}>
              {/* ... (your table cells) */}
             
              {row.cells.map((cell) => (
                    <td {...cell.getCellProps()}>
                      {cell.column.id === 'first_name' ? (
                        <div className='firstName'>
                          <span className='first_letters'>
                            {cell.row.original.first_name.charAt(0) + cell.row.original.last_name.charAt(0)}
                          </span>
                          {cell.render("Cell")}
                        </div>
                      ) : cell.column.id === 'status' ? (
                        <span className={`${cell.row.original.status === "Active" ? 'active' : cell.row.original.status === "Pending" ? 'pending' : 'unactive'}`}>{cell.render("Cell")}</span>
                      ) : 
                        cell.column.id === 'action' ? (
                          <button onClick={() => openModal(row.original)}>View Details</button>
                        ) : (
                          cell.render("Cell")
                        )
                        
                        
                      }
                         
                    </td>
            ))}

              {/* <td {...cell.getCellProps()}>
                {cell.column.id === 'action' ? (
                  <button onClick={() => openModal(row.original)}>View Details</button>
                ) : (
                  cell.render("Cell")
                )}
              </td> */}
            </tr>
          );
        })}
      </tbody>
    </table>

    {isModalOpen && (
      // Create a modal component to display details
      <div className="modal">
        <div className="modal-content">
          <span className="close" onClick={() => setIsModalOpen(false)}>
            &times;
          </span>
          <div>
            {/* Render the details from selectedRowData */}
            <h2>Details</h2>
            <p>ID: {selectedRowData.id}</p>
            <p>First Name: {selectedRowData.first_name}</p>
            {/* Add more details as needed */}
          </div>
        </div>
      </div>
    )}
  </div>
);
};

export default Table;
